export const NEWEST = 'newest'
export const OLDEST = 'oldest'
// TODO: (convo-reordering-after-full-migrations): remove + search for references
export const NEWEST_BY_COLLABORATOR = 'newestByCollaborator'
export const OLDEST_BY_COLLABORATOR = 'oldestByCollaborator'
export const DEFAULT_SORT_ORDER = NEWEST
